'use es6';

import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import { maybeEarlyRequest } from '../utils/earlyRequests';
export var getPortalScopes = function getPortalScopes() {
  return maybeEarlyRequest('portal-scopes', function () {
    return http.get("hubs2/v1/scopes/hub/" + PortalIdParser.get() + "/filter", {
      query: {
        scopes: ['global-content-write-access', 'email-full-editing']
      }
    });
  });
};